module.exports = __webpack_public_path__ + "img/savings-what-is.05a97ff.webp";